import { React, useState } from 'react';
import { CognitoUserAttribute } from 'amazon-cognito-identity-js'
import UserPool from '../UserPool.js'
import BetaModal from '../BetaModalForms/index.js';
import {
  Container,
  FormWrap,
  FormContent,
  Form,
  FormH1,
  FormLabel,
  FormInput,
  FormButton,
  Text,
  NavBtnLink,
  SignUpTermsContainer,
  StyledCheckbox,
  CheckboxText
} from '../SignIn/SigninElements.js';
import { Auth } from 'aws-amplify';

const SignUp = () => {

  const [email, setEmail] = useState('');
  const [confirmCode, setConfirmCode] = useState('')
  const [confirmStatus, setConfirmStatus] = useState(false);
  const [message, setMessage] = useState('');
  const [password, setPassword] = useState('');
  const [passwordOne, setPasswordOne] = useState('');
  const [error, setError] = useState('');
  const [name, setName] = useState('');
  const [verStatus, setVerStatus] = useState(false);
  const [username, setUsername] = useState('');
  const [termsAffirmed, setTermsAffirmed] = useState(false);
  const [betaAffirmed, setBetaAffirmed] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);

  const onSubmit = event => {
    event.preventDefault();

    const attributes = [
      new CognitoUserAttribute({ Name: 'name', Value: name }),
      new CognitoUserAttribute({ Name: 'email', Value: email }),
      new CognitoUserAttribute({ Name: 'username', Value: username })
    ];
    // console.log(attributes)

    if (password !== passwordOne) {
      setError('Passwords do not match')
    }
    else {
      UserPool.signUp(username, password, attributes, null, (err, data) => {
        if (err) setError(err.message);//console.error(err.message);
        else {
          setError('');
          setVerStatus(true);
        }
      })
    }
  };

  const onConfirm = async (event) => {
    event.preventDefault();

    try {
      await Auth.confirmSignUp(username, confirmCode);
      setMessage('Successful Sign Up, your request is now under review.');
      setConfirmStatus(true);
    } catch (err) {
      console.log('Confirmation error:', err);
      setError(err.message);
    }
  };


  const handleModalStatus = async (e) => {
    e.preventDefault();
    setModalStatus(!modalStatus)
  }

  return (
    <>
      <Container>
        <FormWrap>
          <FormContent>
            {verStatus ? (
              <>
                {confirmStatus ? (
                  <Form>
                    <Text>{message}</Text>
                    <NavBtnLink to='/signin'>Sign In</NavBtnLink>
                  </Form>
                ) :
                  <Form>
                    <FormH1>Check Email For Confirmation Code</FormH1>
                    <FormLabel htmlFor='for'>Confirmation Code</FormLabel>
                    <FormInput value={confirmCode} onChange={event => setConfirmCode(event.target.value)} required />
                    <Text>{error}</Text>
                    <FormButton type='submit' checked={true} onClick={onConfirm}>Submit</FormButton>
                  </Form>
                }
              </>
            ) :
              <Form action='#'>
                <FormH1>Create Account</FormH1>
                <FormLabel htmlFor='for'>Name</FormLabel>
                <FormInput value={name} onChange={event => setName(event.target.value)} required />
                <FormLabel htmlFor='for'>Email</FormLabel>
                <FormInput type='email' value={email} onChange={event => setEmail(event.target.value.toLowerCase())} required />
                <FormLabel htmlFor='for'>Username</FormLabel>
                <FormInput value={username} onChange={event => setUsername(event.target.value.toLowerCase())} required />
                <FormLabel htmlFor='for'>Password</FormLabel>
                <FormInput type='password' value={passwordOne} onChange={event => setPasswordOne(event.target.value)} required />
                <FormLabel htmlFor='for'>Confirm Password</FormLabel>
                <FormInput type='password' value={password} onChange={event => setPassword(event.target.value)} required />
                <SignUpTermsContainer>
                  <StyledCheckbox checked={termsAffirmed} onChange={() => setTermsAffirmed(!termsAffirmed)} />
                  <CheckboxText to='/'>Agree to <a href='/termsofservice' target="_blank">Terms Of Service</a></CheckboxText>
                </SignUpTermsContainer>
                <SignUpTermsContainer>
                  <StyledCheckbox checked={betaAffirmed} onChange={() => setBetaAffirmed(!betaAffirmed)} />
                  <CheckboxText to='/'>Agree to <a style={{ color: "Blue", cursor: "pointer" }} onClick={(e) => handleModalStatus(e)} target="_blank">Beta Paticipation</a></CheckboxText>
                </SignUpTermsContainer>
                <FormButton type='submit' disabled={!(termsAffirmed && betaAffirmed)} checked={termsAffirmed && betaAffirmed} onClick={onSubmit}>Request</FormButton>
                <Text>{error}</Text>
                <Text>Already have an account</Text>
                <NavBtnLink to='/signin'>Sign In</NavBtnLink>
              </Form>
            }
          </FormContent>
        </FormWrap>
        <BetaModal isOpen={modalStatus} onClose={(e) => handleModalStatus(e)} />
      </Container>
    </>
  );
};

export default SignUp;
